<p-card class="xl-radius">
    <ng-template #header>
        <div class="row" [style]="{ 'padding': '1.5rem', 'border-bottom': '1px solid #e0e0e0' }">
            <div class="col-2">
                <img class="icon-smaller" src="icons/invoices-icon.png" />
            </div>
            <div class="col-10">
                <h5 [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">Facturen</h5>
            </div>
        </div>
    </ng-template>
    @for(key of Object.keys(invoicesGroupedByMonth); track $index) {
    <div class="row" [style]="{ 'border-bottom': '1px solid #e0e0e0' }">
        <div class="col-6">
            <p [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">{{key | date: 'MMMM yyyy'}}</p>
        </div>
        <div class="col-3">
            <p [style]="{ 'margin-block-start': 0, 'margin-block-end': 0 }">{{getSum(invoicesGroupedByMonth[key]) | currency: 'EUR'}}</p>
        </div>
        <div class="col-3">
            <p-tag [severity]="getInvoiceStatusClass(getInvoiceStatus(invoicesGroupedByMonth[key]))">{{getInvoiceStatus(invoicesGroupedByMonth[key])}}</p-tag>
        </div>
    </div>
    }
    <ng-template #footer>
        <div class="row">
            <div class="col-6">
            </div>
            <div class="col-6">
                <p-button [styleClass]="'float-right'" [outlined]="true" (click)="activeTab = 'invoices'; activeTabChange.emit(activeTab)">Facturen bekijken</p-button>
            </div>
        </div>
    </ng-template>
</p-card>